import _ from 'lodash'
import { useMemo } from 'react'
import { CATEGORY_TYPE } from 'src/libs/constant'
import { createRangeTimeOptions } from 'src/libs/date'
import { useGetCategories } from './useGetCategoriesV2'

export function useGetCategoryOptions (type) {
  const { categories } = useGetCategories(type)
  return useMemo(() => {
    if (categories) {
      return createOption(categories, type)
    }
    return []
  }, [categories])
}

function createOption (list, type) {
  let rs = []

  switch (type) {
    case CATEGORY_TYPE.CLASS_TIME_SLOT:
      rs = createRangeTimeOptions(list, { optionLabelFormat: 'START - END', optionValueByKey: 'id' })
      break
    case CATEGORY_TYPE.LEVEL:
    case CATEGORY_TYPE.REGION:
    case CATEGORY_TYPE.GRADE:
      rs = _.map(list, (x) => ({ value: x.id, label: x.name, level: x.value, code: x.code }))
      rs = _.sortBy(rs, (rs) => (rs.level))
      break
    case CATEGORY_TYPE.STUDY_PROGRAM:
      rs = _.map(list, (x) => ({
        value: x.id,
        label: x.name,
        code: x.code,
        maxStudentInClass: x.maxStudentInClass,
        learningModel: x.learningModel,
        productTypeCode: x.productTypeCode,
        scheduleType: x.scheduleType,
        sessionsPerWeek: x.sessionsPerWeek,
      }))
      break
    case CATEGORY_TYPE.VIOLATION_LEVEL:
      rs = _.map(list, (x) => ({ value: x.id, label: x.name }))
      break
    default:
      rs = _.map(list, (x) => ({ value: x.id, label: x.name, code: x.code }))
  }

  return rs
}
